import BaseUseCase from "../../../base_use_case.js";

class DeletePageUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "delete",
      url: `/api/v1/admin/frontend/pages/${identifier}`,
      params: {
        findBySlug: true
      },
    });
  }
}

const instance = new DeletePageUseCase();
export default instance;
